(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('CouponDetailController', CouponDetailController);

    CouponDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Coupon', 'Brokerage'];

    function CouponDetailController($scope, $rootScope, $stateParams, entity, Coupon, Brokerage) {
        var vm = this;

        vm.coupon = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:couponUpdate', function(event, result) {
            vm.coupon = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
